import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { PROFILE_TEXT, URLS, checkAuth, getLoggedInData} from '../helpers/Common';
import {SURGEON} from '../services/Surgeon';
import Header from "./Header";
import Menu from "./Menu";

class Profile extends Component {

  constructor(props) {
    super(props);
    this.state =
      {
        formData:
        {
          surgeon_id: '',
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          password: '',
          confirm_password: '',
        },
        first_nameError: '',
        last_nameError: '',
        emailError: '',
        passwordError: '',
        phoneError: '',
        confirm_passwordError: '',
        profileData: '',
      };
    this.submit = this.submit.bind(this);
    this.getLoggedInData  = getLoggedInData.bind(this)// Import from common
    this.checkAuth        = checkAuth.bind(this)// Import from common
  }
  componentDidMount()
    {   
        //Get data from API's
        checkAuth();
        let userData = getLoggedInData();
        this.setState({
          userData: userData,
          surgeon_id: userData.user_id
        });
        SURGEON.getProfile(userData.user_id).then(res => {
          if(res.data.header.error==0)
          {   
            this.setState({
              profileData: res.data.body.details[0],
              isLoading: false,
            });
          }
        }).catch(err => {
            this.setState({
                isLoading: false,
            });
           
            return err;
        });
        
    }
  handleChange = (e) => {
    let text = 'Please Enter Valid ';
    let errorKey = e.target.name + "Error";
    let formData = this.state.formData;
    var flag = true;

    if (e.target.name === "first_name") {
      const re = /^[a-zA-Z][a-zA-Z\s]*$/;
      if (!re.test(e.target.value)) {
        flag = false;
        this.setState({
          first_nameError: text + this.formatText(e.target.name),
        });
      }
      if (e.target.value.length === 0) {
        this.setState({
          first_nameError: ''
        });
      }
    }

    if (e.target.name === "last_name") {
      const re = /^[a-zA-Z][a-zA-Z\s]*$/;
      if (!re.test(e.target.value)) {
        flag = false;
        this.setState({
          last_nameError: text + this.formatText(e.target.name),
        });
      }
      if (e.target.value.length === 0) {
        this.setState({
          last_nameError: ''
        });
      }
    }



    if (flag) {
      formData[e.target.name] = e.target.value;
      this.setState({
        formData: formData,
        [errorKey]: ''
      });
    }
  }

  formatText = (text) => {
    text = text.toLowerCase()
      .split('_')
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ');
    return text;
  }

  handleDateChange = (date) => {
    let name = "dob"
    let errorKey = name + "Error";
    let formData = this.state.formData;
    let formattedDate = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate() + 1)).slice(-2);
    formData[name] = formattedDate;
    this.setState({
      startDate: date,
      formData: formData,
      [errorKey]: ''
    });
  }

  handleDateChangeRaw = (e) => {
    e.preventDefault();
  }

  userProfile = (e) => {
    e.preventDefault();
  }

  componentWillMount() {

  }

  submit = (e) => {
    let submitForm = true;

    const re = /^\s*(\+\d{2,3}|00\d{2,3}|\d{1})[-\s]{0,1}(\d{2,4})[-\s]{0,1}(\d{7}\s*)$/g;
    var newString = this.state.formData.phone.replace(/[-\s]/g, '');
    if (!re.test(this.state.formData.phone) || newString.length >= 15) {
      this.setState({
        phoneError: 'Please Enter Valid Phone Number',
      });
      submitForm = false;

    }

    const re2 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re2.test(this.state.formData.email)) {
      this.setState({
        emailError: 'Please Enter Valid Email Address',
      });
      submitForm = false;
    }

    if (!this.state.formData.title) {
      this.setState({
        titleError: 'Title Is Required'
      });
      submitForm = false;
    }

    if (!this.state.formData.first_name) {
      this.setState({
        first_nameError: 'First Name Is Required'
      });
      submitForm = false;
    }

    if (!this.state.formData.last_name) {
      this.setState({
        last_nameError: 'Last Name Is Required'
      });
      submitForm = false;
    }

    if (!this.state.formData.email) {
      this.setState({
        emailError: 'Email Is Required'
      });
      submitForm = false;
    }
    if (!this.state.formData.phone) {
      this.setState({
        phoneError: 'Phone Is Required'
      });
      submitForm = false;
    }
    if (!this.state.formData.dob) {
      this.setState({
        dobError: 'Date Of Birth Is Required'
      });
      submitForm = false;
    }
    if (!this.state.formData.gender) {
      this.setState({
        genderError: 'Gender Is Required'
      });
      submitForm = false;
    }
    if (this.state.titleError !== '' || this.state.last_nameError !== '' || this.state.first_nameError !== '' || this.state.dobError !== '' || this.state.genderError !== '' || this.state.emailError !== '' || this.state.phoneError !== '') {
      submitForm = false;
    }
    submitForm = true;
    if (submitForm) {

      this.props.setProfileData(this.state.formData);
      this.props.handleNextPrevSteps(this.state.nextStep);
      // localStorage.setItem('patientProfileData', JSON.stringify(this.state.formData));
      // this.props.history.push('/complain');
    }

  }

  render() {
    return (
      <React.Fragment>
        
        <Header
            title="Patient Symptoms Narrative"
            titleImage="ic-medical-result.png"
        />
        <Menu />
        <section className="c-login profilePage">
          <div className="bg-overlay" style={{
            backgroundImage: "url(" + require("../assets/img/bg/new-login-bg.jpg") + ")",
          }}></div>
          <div className="container">
            <div className="patient-logo">
              <img src={require("../assets/img/icons/ic-login.png")} alt="" />
              <span>{'Your Profile'}</span>
            </div>
            <div className="login-form">
              <div className="row">
                <div className="col-md-1"></div>
                <div className="col-md-10 col-sm-12">
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <div className={"form-group" + (this.state.first_nameError ? ' error' : '')}>
                        <label htmlFor="">{PROFILE_TEXT.FIRST_NAME} *</label>
                        <input name="first_name" value={this.state.profileData.first_name} onChange={this.handleChange} readOnly type="text" className="form-control" />
                        {this.state.first_nameError ? (
                          <div className='alert-danger'>{this.state.first_nameError}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <div className={"form-group" + (this.state.last_nameError ? ' error' : '')}>
                        <label htmlFor="">{PROFILE_TEXT.LAST_NAME} *</label>
                        <input name="last_name" type="text" value={this.state.profileData.last_name} readOnly onChange={this.handleChange} className="form-control" />
                        {this.state.last_nameError ? (
                          <div className='alert-danger'>{this.state.last_nameError}</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <div className={"form-group" + (this.state.last_nameError ? ' error' : '')}>
                        <label htmlFor="">Email *</label>
                        <input name="last_name" value={this.state.profileData.email} readOnly type="text" onChange={this.handleChange} className="form-control" />
                        {this.state.last_nameError ? (
                          <div className='alert-danger'>{this.state.last_nameError}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <div className={"form-group" + (this.state.emailError ? ' error' : '')}>
                        <label htmlFor="">Phone *</label>
                        <input type="text" name="email" value={this.state.profileData.mobile_no} readOnly onChange={this.handleChange} className="form-control" />
                        {this.state.emailError ? (
                          <div className='alert-danger'>{this.state.emailError}</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <div className="form-btn">
                        <button className="btn" onClick={this.submit}>Save</button>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

        </section>
        {/* <Footer /> */}
      </React.Fragment>
    );
  }
}

export default Profile;